module.exports = __webpack_public_path__ + "img/pdf.dee15129.svg";